module.exports = __webpack_public_path__ + "static/media/12UNCTAD6.c9db78aa.jpg";